import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { PhdSoftPipesModule } from '@phdsoft/pipes';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomFormlyMaterialModule, FormlyBaseModule } from '@phdsoft/formly';
import { BaseFormModule } from '@phdsoft/base-form';
import { MatStepperModule } from '@angular/material/stepper';
import { PhdSoftCommonModule } from '@phdsoft/common';
import { MatDialogModule } from '@angular/material/dialog';
import { ModalConfirmModule } from '@phdsoft/modal-confirm';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { PropertiesWindowModule } from '@phdsoft/properties-window';
import { MatRadioModule } from '@angular/material/radio';
import { MatBadgeModule } from '@angular/material/badge';
import { CollectionInspectionGauginsPositioningWizardComponent } from './collection-inspection-gaugins-positioning-wizard/collection-inspection-gaugins-positioning-wizard.component';
import { CollectionInspectionSettingsPlatesComponent } from './collection-inspection-settings-plates/collection-inspection-settings-plates.component';
import { CollectionInspectionSettingsStiffenersComponent } from './collection-inspection-settings-stiffeners/collection-inspection-settings-stiffeners.component';
import { CollectionInspectionSettingsFacePlatesComponent } from './collection-inspection-settings-face-plates/collection-inspection-settings-face-plates.component';
import { CollectionInspectionSettingsBracketsComponent } from './collection-inspection-settings-brackets/collection-inspection-settings-brackets.component';
import { CarouselModule } from 'primeng/carousel';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { RegionSelectComponent } from './region-select/region-select.component';
import { CollectionInpectionSettingsWindowComponent } from './collection-inpection-settings-window/collection-inpection-settings-window.component';
import { RegionSelectionComponent } from './region-selection/region-selection.component';
import { AutomaticPointsSettingsContainerComponent } from './automatic-points-settings-container/automatic-points-settings-container.component';
import { StepsModule } from 'primeng/steps';
import { RiskInspectionComponent } from './risk-inspection/risk-inspection.component';
import { AutomaticPlanTypeSelectorComponent } from './automatic-plan-type-selector/automatic-plan-type-selector.component';
import { AutomaticPlanAreaWizardComponent } from './automatic-plan-area-wizard/automatic-plan-area-wizard.component';
import { RiskShieldComponent } from './risk-shield/risk-shield.component';
import { TableModule } from 'primeng/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DialogModule } from 'primeng/dialog';
import { RiskMatrixComponent } from './risk-matrix/risk-matrix.component';
import { DropdownModule } from 'primeng/dropdown';
import { AccordionModule } from 'primeng/accordion';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ConsequenceMapComponent } from './consequence-map/consequence-map.component';
import { RiskAssessmentComponent } from './risk-assessment/risk-assessment.component';
import { IndeterminateDirective } from './region-selection/indeterminate.directive';
import { SideBoardModule } from "@app/side-board/side-board.module";
import { InspectionPlanSelectorModule } from '@app/collections/inspection-plan-selector/inspection-plan-selector.module';
import { PhdSoftWindowModule } from '@phdsoft/window';
import { MatTreeModule } from '@angular/material/tree';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
  declarations: [
    CollectionInspectionGauginsPositioningWizardComponent,
    CollectionInspectionSettingsPlatesComponent,
    CollectionInspectionSettingsStiffenersComponent,
    CollectionInspectionSettingsFacePlatesComponent,
    CollectionInspectionSettingsBracketsComponent,
    RegionSelectComponent,
    CollectionInpectionSettingsWindowComponent,
    RegionSelectionComponent,
    AutomaticPointsSettingsContainerComponent,
    RiskInspectionComponent,
    AutomaticPlanTypeSelectorComponent,
    AutomaticPlanAreaWizardComponent,
    RiskShieldComponent,
    RiskMatrixComponent,
    RiskAssessmentComponent,
    ConsequenceMapComponent,
    IndeterminateDirective,
  ],
  imports: [
    CarouselModule,
    ButtonModule,
    ToastModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatExpansionModule,
    MatListModule,
    MatInputModule,
    MatFormFieldModule,
    MatRadioModule,
    MatDialogModule,
    DialogModule,
    ModalConfirmModule,
    MatSnackBarModule,
    MatStepperModule,
    MatSelectModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatBadgeModule,
    DragDropModule,
    PhdSoftPipesModule,
    PhdSoftCommonModule,
    TableModule,
    CustomFormlyMaterialModule,
    FormlyBaseModule,
    BaseFormModule,
    RouterModule,
    PropertiesWindowModule,
    StepsModule,
    MatProgressSpinnerModule,
    DropdownModule,
    AccordionModule,
    ScrollingModule,
    SideBoardModule,
    InspectionPlanSelectorModule,
    PhdSoftWindowModule,
    MatTreeModule,
    MatTabsModule
  ],
  providers: [
  ],
  exports: [
    CollectionInspectionGauginsPositioningWizardComponent,
    CollectionInspectionSettingsPlatesComponent,
    CollectionInspectionSettingsStiffenersComponent,
    CollectionInspectionSettingsFacePlatesComponent,
    CollectionInspectionSettingsBracketsComponent,
    RiskInspectionComponent,
    AutomaticPlanTypeSelectorComponent,
    AutomaticPlanAreaWizardComponent,
    RiskShieldComponent,
    RiskMatrixComponent,
    RiskAssessmentComponent,
    ConsequenceMapComponent,
    RegionSelectComponent,
  ]
})
export class AutomaticPointsModule {
}
